import { action, makeObservable, observable } from 'mobx'
import moment from 'moment'
import FormStore from '../../../../../utils/stores/FormStore'
import { getComp } from '../../../../../utils/utils/DI'

export const initParamsState = {
  from: null,
  to: null,
  installedFrom: null,
  installedTo: null,
  status: '',
  statuses: [],
  phone: '',
  dealer: '',
  dealerIds: [],
  id: '',
  source: '',
  senderId: '',
  authorId: '',
  authorName: '',
  preferentialCategory: '',
  categories: [],
  address: '',
  fullName: '',
  equipmentId: '',
  dataCheckingStatus: [],
  agreementCheckingStatus: [],
  reasonId: '',
  reason: '',
  priority: '',
  financialSourceIds: [],
  priorities: [],
  IsStrictSearch: false,
  hasDuplicates: false,
  isExpired: false,
  isSuspicious: false,
  surnamePartial: '',
  namePartial: '',
  territory: '',
  district: '',
  locality: '',
  SenderGroupIds: [],
  reportId: '',
  orderId: '',
  sender: '',
  isDangerous: '',
  year: '',
  installationYear: '',
}

const validateData = {
  status: { required: true },
}

class RequestsTableFilterStore extends FormStore {
  dealersStore: any
  data: any = initParamsState
  initParams: any
  param: any
  constructor(initParams?: any) {
    super({
      initState: initParams ?? initParamsState,
      validateData,
    })
    this.data = initParams ?? initParamsState
    this.initParams = initParams ?? initParamsState
    this.dateNames = [
      ['from', 'to'],
      ['installedFrom', 'installedTo'],
    ]
    this.dealersStore = getComp('DealersStore')
    makeObservable(this, {
      isHighlighted: observable,
      data: observable,
      makeHighlightTrue: action,
      makeHighlightFalse: action,
    })
  }

  isHighlighted = false

  makeHighlightTrue = () => {
    if (this.data?.id !== '') {
      return
    }
    this.isHighlighted = true
  }

  makeHighlightFalse = () => (this.isHighlighted = false)

  clear = () => {
    this.setData({ ...this.initParams, financialSourceIds: [] })
    this.makeHighlightFalse()
    this.param = null
    this.clearSelectedFilters()
  }

  makeParamCopy = (param: any) => {
    this.param = param
  }

  getParamCopy = () => this.param

  getParams = () => {
    const param = {} as Record<string, any>

    for (const key in this.data) {
      if (!!this.data[key]) {
        switch (key) {
          case 'dealerIds':
            if (this.data[key] === 'none') {
              param.withNoDealer = true
              break
            }
            param[key] = this.data[key].map(
              (aid: any) =>
                getComp('DealersStore').getDealerBuyAid(aid)?.subjectId,
            )
            break
          case 'from':
          case 'installedFrom':
            param[key] = this.data[key].format('YYYY-MM-DDTHH:mm:ssZ')
            break
          case 'to':
          case 'installedTo':
            param[key] = moment(this.data[key])
              .add(1, 'days')
              .format('YYYY-MM-DDTHH:mm:ssZ')
            break
          case 'source':
            param['sourceId'] = this.data[key]
            break
          case 'senderId':
          case 'sender':
            param['senderId'] = getComp('SendersStore').getSenderId(
              this.data[key],
            )
            break
          case 'authorId':
            param['authorId'] = getComp('AuthorsStore').getIdByName(
              this.data[key],
            )
            break
          case 'id':
            param['orderId'] = this.data[key]
            break
          case 'phone':
            param['phone'] = normalizePhoneNumber(this.data[key])
            break
          case 'phoneNumber':
            param['phoneNumber'] = normalizePhoneNumber(this.data[key])
            break

          case 'isDangerous':
            let val = undefined
            if (this.data[key] === 'Включить заявки в проблемных зонах')
              val = true
            if (this.data[key] === 'Исключить заявки в проблемных зонах')
              val = 'false'

            param['isDangerous'] = val
            break

          case 'financialSourceIds':
            if (!this.data[key].length && this.initParams[key].length) {
              param[key] = this.initParams[key]
            } else {
              param[key] = this.data[key]
            }
            break
          default:
            param[key] = this.data[key]
            break
        }
      }
    }
    return param
  }
}

function normalizePhoneNumber(phoneNumber: string | number) {
  return String(phoneNumber).replace(/\D/g, '')
}

export const requestsFilterStore = new RequestsTableFilterStore()
export type RequestsTableFilterStoreType = InstanceType<
  typeof RequestsTableFilterStore
>
export default RequestsTableFilterStore
